import React, { useState } from 'react';
import { Code2, X } from 'lucide-react';
import EmbedCodeGenerator from './EmbedCodeGenerator';

/**
 * Pops the EmbedCodeGenerator inside a centered modal. Used by list-style
 * dashboards (OrganizationDashboard event rows) so admins can grab their
 * widget snippet in one click without leaving the page.
 *
 * Exposes both the trigger button AND the dialog under one component so
 * callers just render `<EmbedCodeDialogButton event={ev} />`.
 */
export default function EmbedCodeDialogButton({ event, className = '', testid }) {
  const [open, setOpen] = useState(false);
  if (!event || (event.kind !== 'experience' && event.kind !== 'reservation')) return null;

  return (
    <>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        className={`p-1.5 rounded hover:bg-card border border-transparent hover:border-border text-cyan-300 hover:text-cyan-200 transition-colors ${className}`}
        title="Get embed code"
        data-testid={testid || `embed-btn-${event.event_id}`}
        aria-label="Get embed code"
      >
        <Code2 className="h-3.5 w-3.5" />
      </button>

      {open && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
          onClick={() => setOpen(false)}
          data-testid="embed-dialog-overlay"
        >
          <div
            className="bg-card rounded-2xl border border-border w-full max-w-2xl max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
            data-testid="embed-dialog"
          >
            <div className="flex items-center justify-between p-4 border-b border-border sticky top-0 bg-card z-10">
              <h2 className="font-bold text-base">Embed “{event.name}” on your site</h2>
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="p-1.5 rounded hover:bg-muted text-muted-foreground"
                aria-label="Close"
                data-testid="embed-dialog-close"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
            <div className="p-4">
              <EmbedCodeGenerator event={event} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
